
import { Vue, Component, Prop } from "vue-property-decorator";
import S3Image from "@/components/common/s3-image.vue";
import { hslColorFromName } from "@/utils/hslColorFromName";

import RouteParams from "@/entities/RouteParams";
import RouteNames from "@/entities/RouteNames";

@Component({
  components: {
    S3Image,
  },
})
export default class ItemChip extends Vue {
  @Prop({ type: [String, Number], default: undefined }) readonly itemId?:
    | string
    | number;
  @Prop({ type: String, required: true }) readonly itemName!: string;
  @Prop({ type: String }) readonly avatarColor!: string;
  @Prop({ type: [String, Number], default: undefined }) readonly itemExtra?:
    | string
    | number;
  @Prop({ type: String, default: undefined }) readonly avatar?: Boolean;
  @Prop({ type: String, default: undefined }) readonly routeName?: RouteNames;
  @Prop({ type: Boolean, default: false }) readonly isPerson!: boolean;
  @Prop({ type: Boolean, default: false }) readonly showPointer!: boolean;
  @Prop({ type: String, default: undefined }) readonly maxChipWidth?: string;
  @Prop({ type: Object, default: () => ({}) }) readonly routeParams!: Partial<
    RouteParams<{ id: string }>
  >;
  @Prop({ type: Boolean, default: false }) readonly removed!: boolean;
  @Prop({ type: String, default: undefined }) readonly backGround?: string;
  @Prop({ type: String, default: undefined }) readonly adjustPadding?: string;
  @Prop({ type: String, default: undefined }) readonly adjustGap?: string;
  @Prop({ type: String, default: undefined }) readonly textClasses?: string;
  @Prop({ type: Boolean, default: false }) readonly single!: boolean;
  @Prop({ type: Boolean, default: false }) readonly hideBorder!: boolean;
  @Prop({ type: Boolean, default: false, required: false })
  readonly management!: boolean;

  get containerClasses(): Record<string, boolean> {
    return {
      ["mb-0.5"]: !this.single,
      [this.chipWidth]: Boolean(this.chipWidth),
    };
  }

  get adjustSpacing(): Record<string, boolean> {
    return  {
      ["gap-1"]: !Boolean(this.adjustGap),
  }
  }

get bgStyle(): string {
    return this.backGround;
  }

  get labelColor(): string {
    return ""
    // if (this.hideBorder) return "text-primary-black";
  }

  get textStyles(): Record<string, boolean> {
    return {
      [String(this.textClasses)]: Boolean(this.textClasses),
      ["text-sm sm:truncate"]: !Boolean(this.textClasses),
     
    };
  }

  get blockIndentationClasses(): Record<string, boolean> {
    return {
      "py-1 px-2": !this.shouldDisplayAvatar && !this.shouldDisplayAvatarPlaceholder,
    };
  }

  get isLink(): boolean {
    return (!!this.routeName || !!this.routeParams.name) && !!this.itemId;
  }

  get removedTextClasses(): Record<string, boolean> {
    return {
      "border-red-500 text-red-300 hover:text-red-500 hover:border-red-500 rounded-full":
        this.removed && !this.hideBorder,
      "border-gray-300 text-gray-500 hover:text-primary-500 hover:border-primary-500":
        !this.removed && !this.hideBorder,
      "border-none": this.hideBorder,
    };
  }

  get imageContainerClasses(): Record<string, boolean> {
    return {
      ["cursor-pointer"]: this.showPointer,
      ["cursor-default"]: !this.showPointer,
      ["bg-greenChip text-lightGreen"]: this.management && !this.hideBorder,
      ["bg-snow-white text-storm-gray"]: !this.management && !this.hideBorder,
      ["bg-white"]: this.hideBorder,
    };
  }
get adjustPad(): Record<string, boolean> {
    return {
      ["customPadding"]: this.adjustPadding === "true",
    };
  }
  get indentationClasses(): Record<string, boolean> {
    return {
      ["mb-1 mr-1 p-1"]: true,
    };
  }

  get chipWidth(): string {
    if (this.maxChipWidth) {
      return this.maxChipWidth;
    }

    return "maxChipWidth";
  }

  get shouldDisplayAvatar(): boolean {
    return this.isPerson && Boolean(this.avatar);
  }

  get shouldDisplayAvatarPlaceholder(): boolean {
    return this.isPerson && !this.avatar;
  }

  get routeLinkParams(): RouteParams<{ id: string }> {
    if (this.routeParams.name) {
      return this.routeParams as RouteParams<{ id: string }>;
    }

    return {
      name: this.routeName!,
      params: { id: String(this.itemId) },
    };
  }

  get initial(): string {
    return this.itemName.trim().toUpperCase()[0];
  }
}
